import { routeTo } from 'redux-router-kit';

import * as CollectEmail from 'app/entities/CollectEmail';
import { NEW_SUBMIT_EMAIL_FORM } from 'app/zapbook/utils/constants';
import { makeQueryString } from 'app/common/utils/UrlUtils';

const ZapbookActions = {
  addParamsToHash(sort, filter) {
    return (dispatch, getState) => {
      if (filter) {
        return dispatch(ZapbookActions.routeToCategory(filter, sort));
      }
      const { router } = getState();
      const current = router.current;
      const queryString = makeQueryString({}, { sort });
      const route = `${current.location.origin}${current.location.pathname}#${queryString}`;
      return dispatch(routeTo(route));
    };
  },

  routeToCategory(category, sortBy) {
    return dispatch => {
      if (sortBy && sortBy !== 'popular') {
        sortBy = makeQueryString({}, { sort: sortBy });
        sortBy = `#${sortBy}`;
      } else {
        sortBy = '';
      }

      return dispatch(routeTo(`/apps/categories/${category}${sortBy}`));
    };
  },

  routeToZap(url, isLoggedIn) {
    return isLoggedIn ? routeTo(url) : routeTo(`/sign-up/?next=${url}`);
  },

  initializeSubmitEmailForm() {
    const id = NEW_SUBMIT_EMAIL_FORM;
    return CollectEmail.actions.createCollectionUiEntity({ id, email: '' });
  },

  updateEmail(email, id) {
    return CollectEmail.actions.updateEmail(email, id);
  },

  voteForApp(services, id) {
    return CollectEmail.actions.voteForApp(
      {
        success: 'Thanks! Your vote was successfully added.',
        error:
          'Sorry! There was a problem submitting your email. Please try again, or contact support if the problem persists.',
      },
      id,
      services
    );
  },
};

export default ZapbookActions;
